import {
  MutationOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { GeneralResponse } from "../../interface/GeneralResponse";
import Api from "../generalApi/Api";
import { Methods } from "../../Constants/ApiConstants";
import { refetchAllAppointmentsApis } from "./refetchAllAppointmentsApis";

interface IChangeAppointmentStatus {
  AppointmentId: number;
  Status: string;
  Note: string;
}

export const useChangeAppointmentStatusMutation = (
  options?: MutationOptions,
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any): Promise<GeneralResponse> => {
      return Api<IChangeAppointmentStatus, GeneralResponse>({
        method: Methods.POST,
        endpoint: `Appointment/${data?.action}/${data?.AppointmentId}`,
        filter: [data],
      });
    },
    ...options,
    onSuccess: (data: unknown, variables: void, context: unknown) => {
      refetchAllAppointmentsApis(queryClient);
      options?.onSuccess && options.onSuccess(data, variables, context);
    },
  });
};
